// constant variables for question types.

export const MULTIPLE_QUE_TYPE = {
  id: "multiple",
  label: "Multiple choice",
};

export const SINGLE_QUE_TYPE = {
  id: "single",
  label: "Single choice",
};

export const FREE_QUE_TYPE = {
  id: "free",
  label: "Free text",
};

export const QuestionTypes = [
  {
    value: MULTIPLE_QUE_TYPE.id,
    label: MULTIPLE_QUE_TYPE.label,
    icon: "fa fa-check-square",
  },
  {
    value: SINGLE_QUE_TYPE.id,
    label: SINGLE_QUE_TYPE.label,
    icon: "fa fa-dot-circle-o",
  },
  { value: FREE_QUE_TYPE.id, label: FREE_QUE_TYPE.label, icon: "fa fa-font" },
];
